<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2020-12-07 15:03:53
 * @LastEditors: sueRimn
 * @LastEditTime: 2020-12-09 14:20:27
-->
<template>
  <div class="OutAmount">
    <AmountPageOut textButton="确认转出" :getAmountNum="getAmountNum" />
    <self-popup v-model="ShowPopupContent"></self-popup>
  </div>
</template>
<script>
import { milliFormat } from '@/utils';
import { mapState, mapMutations } from 'vuex';
import AmountPageOut from './components/AmountPageOut.vue';

export default {
  name: 'OutAmount',
  data() {
    return {
      amountValue: '0.00',
      // 弹窗
      ShowPopupContent: '',
    };
  },
  components: {
    AmountPageOut,
  },
  computed: {
    ...mapState({
      capitalAccount(val) {
        return val.capitalAccount;
      },
    }),
  },
  methods: {
    ...mapMutations('capitalAccount', ['updateState']),
    getAmountNum(val, cb) {
      this.amountValue = milliFormat(val.amountValue);
      const { orderId } = this.capitalAccount;
      this.$api.CommonForms.bandlerWithdrawal({
        orderId,
        amount: val.amountValue,
        bindingCardId: val.selectValueID,
      }).then((res) => {
        if (res.success) {
          this.$router.push(
            `/supermarket/v2/ToIntoing?trans_no=${
              res.data.trans_no
            }&isInto=${false}&orderId=${orderId}&amount=${val.amountValue}`,
          );
        } else if (!res.success && res.returnCode === 'EDC0002') {
          this.$router.push(
            `/supermarket/v2/ToIntoFail?ret_msg=${res.returnMessage}&isText=转出&orderId=${orderId}&retCode=${res.returnCode}`,
          );
        } else {
          this.ShowPopupContent = res.returnMessage;
        }
        // eslint-disable-next-line no-unused-expressions
        cb && cb();
      }).catch(() => {
        this.ShowPopupContent = '网络异常，请稍后再试！';
      });
    },
  },
};
</script>
<style scoped>

</style>
